<template>
    <b-card class="p-0">
        <div class="d-flex justify-content-between align-items-center">
            <b-card-title>Valoración</b-card-title>
            <Button icon="fas fa-pen" class="ml-3" v-b-modal.modalForm>{{ valoracion ? 'Editar' : 'Crear' }}</Button>
        </div>
        <b-card-text>
            <div>
                
            </div>
            <div v-if="valoracion">
                <GChart type="BarChart" :data="chartData" :options="chartOptions" class="w-auto" />
            </div>

            <b-modal id="modalForm" title="EDITAR VALORACIÓN" hide-footer>
                <FormValoracion :base_id="base_id" :valoracion="valoracion" @edit="getBase"/>
            </b-modal>
        </b-card-text>
    </b-card>
</template>

<script>
    import FormValoracion from '@/components/backend/bases/components/valoraciones/FormValoracion.vue';
    export default {
        props: ['valoracion', 'base_id'],
        data() {
            return {
                chartData: [
                    ['Tipo', 'Puntaje', { role: 'style' }],
                    ['Val.Técnica', this.valoracion ? this.valoracion.tecnica : 0, 'red'],
                    ['Val.Táctica', this.valoracion ? this.valoracion.tactica : 0, 'green'],
                    ['Cap.Física', this.valoracion ? this.valoracion.fisica : 0, 'purple'],
                    ['Psicológica', this.valoracion ? this.valoracion.psicologica : 0, 'blue'],
                    ['Personalidad', this.valoracion ? this.valoracion.personalidad : 0, 'gold'],
                    ['Media', this.valoracion ? this.valoracion.media : 0, 'orange']
                ],
                chartOptions: {
                    hAxis: {
                        maxValue: 10,
                        minValue: 0
                    },
                    legend: {
                        position: 'left'
                    }
                },
            }
        },
        methods: {
            getBase() {
                this.$emit('getBase');
            }
        },
        components: {
            FormValoracion
        },
    }
</script>